import { ReactNode, Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import Sidebar from '@/components/dashboard/sidebar'
import Loading from '@/components/loading'
import { useModel } from '@/store'

export default function AppLayout() {
  const { init, loading } = useModel((state) => state)

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      {loading ? (
        <div className="w-screen h-screen flex items-center justify-center">
          <Loading />
        </div>
      ) : (
        <div className="flex h-screen flex-col bg-white text-body dark:bg-dark-14 dark:text-dark-body">
          <div className="flex-grow overflow-auto">
            <div className="flex h-full">
              <Sidebar />
              <section className="relative mx-auto w-full max-w-200 overflow-auto">
                {/* 原有导航条需要整理到现在的导航条 TODO */}
                <main className="relative min-h-screen">
                  <Suspense
                    fallback={
                      <div className="w-full h-full flex items-center justify-center min-h-96">
                        <Loading />
                      </div>
                    }
                  >
                    <Outlet />
                  </Suspense>
                </main>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
